import React from 'react';
import Tooltip from '@/components/ui/Tooltip';
import cn from '@/utils/cn';
import homeIcon from '@images/icons/home-white.svg';
import gradesIcon from '@images/icons/bar-outline.svg';
import lessonOverviewIcon from '@images/icons/hand.svg';
import readingIcon from '@images/icons/open-books-white.svg';
import gamesLibraryIcon from '@images/icons/controller-white.svg';
import assignmentIcon from '@images/icons/fa-calendar.svg';
import styles from '../LeftNavBarTabs.module.scss';

const ICONS = {
  assignments: assignmentIcon,
  games: gamesLibraryIcon,
  grades: gradesIcon,
  home: homeIcon,
  overview: lessonOverviewIcon,
  reading: readingIcon,
} as const;

interface Tab {
  active: boolean;
  icon: 'home' | 'assignments' | 'grades' | 'overview' | 'reading' | 'games';
  linksTo: string;
  tooltip: string;
}

interface NavProps {
  tabs: Tab[];
}

const Nav = ({ tabs }: NavProps) => (
  <nav aria-label="Main navigation" className="tw-mt-6">
    <ul className="tw-flex tw-flex-col tw-gap-6 tw-list-none tw-m-0 tw-p-0">
      {tabs.map((tab) => {
        const isActive = `${window.location.pathname}${window.location.search}` === tab.linksTo || tab.active;

        return (
          <li key={tab.icon} className="tw-relative tw-flex tw-justify-center">
            {isActive && (
              <span aria-hidden className="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-[7px] tw-bg-white" />
            )}
            <Tooltip.Provider delayDuration={0}>
              <Tooltip>
                <Tooltip.Trigger asChild>
                  <a
                    aria-current={isActive ? 'page' : undefined}
                    aria-label={`Navigate to ${tab.tooltip}`}
                    className={cn(
                      `tw-bg-transparent tw-border-none tw-rounded tw-w-4/5 tw-aspect-square tw-cursor-pointer
                       tw-flex tw-items-center tw-justify-center hover:tw-bg-white
                       hover:tw-bg-opacity-25 focus:tw-bg-white focus:tw-bg-opacity-25
                       focus:tw-outline-2 focus:tw-outline-white focus:tw-outline-offset-2`,
                      { 'tw-bg-white tw-bg-opacity-25': isActive },
                    )}
                    href={tab.linksTo}
                    tabIndex={0}
                  >
                    <img alt="" aria-hidden="true" className="tw-fill-amber-500" src={ICONS[tab.icon]} />
                  </a>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                  <Tooltip.Content
                    aria-hidden="true"
                    className={cn('tw-z-9999 tw-bg-white tw-py-2 tw-px-6 tw-rounded', styles.tooltipShadow)}
                    side="right"
                    sideOffset={14}
                  >
                    {tab.tooltip}
                    <Tooltip.Arrow className="tw-fill-white tw-bg-transparent" />
                  </Tooltip.Content>
                </Tooltip.Portal>
              </Tooltip>
            </Tooltip.Provider>
          </li>
        );
      })}
    </ul>
  </nav>
);

export default Nav;
